'use client';

import { Fragment } from 'react';
import Hero from '@/components/Hero';
import Link from 'next/link';
import VideoTextCard from '@/components/VideoTextCard';
import card1Data from '@/textContent/solutions/accounting/card1Data.json';
import card2Data from '@/textContent/solutions/accounting/card2Data.json';
import { motion } from 'framer-motion';

/* ---------------- Animation Variant ---------------- */

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.6,
            ease: 'easeOut',
        },
    },
};

const Page = () => {
    const heroTextContent = {
        heading: 'ERPNext Accounting and Finance Solutions',
        caption:
            'Manage GST, receivables, payables, inventory accounting and financial reporting in one connected system. Wahni helps businesses in Kerala, Bangalore and across India connect finance with everyday operations through ERPNext.',
        image: '/images/hero/accounts.png',
        buttonText: 'Contact Sales',
        buttonLink: '/contact-sales',
    };

    return (
        <Fragment>
            {/* Hero Section */}
            <motion.div variants={fadeUp} initial="hidden" animate="visible">
                <Hero {...heroTextContent} />
            </motion.div>

            {/* Card 1 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
            >
                <VideoTextCard data={card1Data} />
            </motion.div>

            {/* Card 2 */}
            <motion.div
                variants={fadeUp}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="p-5 md:flex md:items-center md:justify-center md:px-[12vw] mb-5"
            >
                <VideoTextCard data={card2Data} />
            </motion.div>

            {/* CTA */}
            <section className="w-full pb-16 md:pb-20 px-4">
                <motion.div
                    className="max-w-3xl mx-auto text-center bg-gray-50 rounded-3xl p-8 md:p-12"
                    initial={{ opacity: 0, scale: 0.96 }}
                    whileInView={{ opacity: 1, scale: 1 }}
                    viewport={{ once: true, amount: 0.3 }}
                    transition={{ duration: 0.6, ease: 'easeOut' }}
                >
                    <h2 className="text-2xl md:text-3xl font-bold text-gray-800">
                        Ready to Connect Your Accounting with Your Business
                    </h2>
                    <p className="mt-3 text-gray-600 text-base md:text-lg">
                        Explore ERPNext accounting and finance solutions
                        configured around your operations.
                    </p>
                    <Link href="/contact-sales">
                        <button className="hello_button py-3 px-10 bg-blue-500 rounded-md mt-6 shadow-xl hover:shadow-none transition duration-300">
                            <span className="font-bold text-white text-sm md:text-base">
                                Contact Sales
                            </span>
                        </button>
                    </Link>
                </motion.div>
            </section>
        </Fragment>
    );
};

export default Page;
